module.exports = __webpack_public_path__ + "img/arrow.2a00ee5e.svg";